import { Box, IconButton, Stack, Typography } from '@mui/material'
import { EmptyTableState } from 'components/purchase/EmptyTableState'
import { formatTimeStampToDate } from 'hooks/date/formattedTime'
import { useTranslation } from 'react-i18next'
import {
  ECommissionEvaluationStatus,
  ICommissionEvaluation,
} from 'types/commission-evaluation/commission-evaluation'
import EastIcon from '@mui/icons-material/East'
import { useNavigate } from 'react-router-dom'

type Props = {
  commissionEvaluations: ICommissionEvaluation[]
  status: ECommissionEvaluationStatus
}

export const CommissionEvaluationItem = ({
  commissionEvaluations,
  status,
}: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  if (commissionEvaluations.length === 0) {
    return <EmptyTableState />
  }

  return (
    <>
      {commissionEvaluations.map((item) => {
        return (
          <Box
            key={item.id}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px',
              background: '#fff',
              padding: '15px',
            }}
          >
            <Stack>
              <Typography variant="caption" fontWeight="bold">
                {t('contestName')}: {item.tenderName}
              </Typography>
              <Typography variant="caption" fontWeight="bold">
                {t('organization')}: {item.submitterOrganizationName}
              </Typography>
            </Stack>
            <Box>
              <Typography variant="caption" fontWeight="bold">
                {t('lot')}: {item.lotName}
              </Typography>
            </Box>
            <Box>
              <Typography variant="caption" fontWeight="bold">
                {t('startDate')}: {formatTimeStampToDate(item.tenderStartTime)}
              </Typography>
            </Box>
            <Box>
              <IconButton
                onClick={() =>
                  navigate(
                    `/portal/tender-committee/details/${item.tenderId}?status=${status}`
                  )
                }
                aria-label="view commission evaluation details"
                color="primary"
              >
                <EastIcon />
              </IconButton>
            </Box>
          </Box>
        )
      })}
    </>
  )
}
